import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, IconButton, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';
import { IoChevronBackSharp } from "react-icons/io5";

// project imports
import MenuList from './MenuList';
// import LogoSection from '../LogoSection';
import MenuCard from './MenuCard';
import { drawerWidth } from 'store/constant';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const drawer = (
    <Box sx={{ overflow: 'hidden', position: 'relative' }}>
      {/* Toggle Button */}
      <IconButton
        onClick={drawerToggle}
        sx={{
          position: 'absolute',
          top: 20,
          right: '-15px', // Adjusted so it's properly visible
          zIndex: 1301,
          background: "#fff",
          borderRadius: '25%',
          boxShadow: 2,
          width: 35,
          height: 35,
          border: `2px solid rgb(170, 169, 169)`,
          '&:hover': { background: theme.palette.grey[200] },
          overflow: 'visible',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IoChevronBackSharp />
      </IconButton>

      <BrowserView>
        <PerfectScrollbar
          component="div"
          style={{
            backgroundColor: "#592375",
            height: '100vh',
            paddingLeft: '0px',
            paddingRight: '0px',
            overflowX: 'hidden', // Prevent horizontal scrolling
          }}
        >
          <MenuCard />
          <MenuList />
        </PerfectScrollbar>
      </BrowserView>
      <MobileView sx={{ backgroundColor: "#592375" ,height:'100%'}}>
        <Box sx={{backgroundColor: "#592375",height:'100vh',overflowY:'scroll',scrollbarWidth:'none'}}>
          <MenuCard />
          <MenuList />
        </Box>
      </MobileView>
    </Box>
  );

  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">

      <Drawer
        container={container}
        variant={matchUpMd ? 'persistent' : 'temporary'}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: 'none',
            margin: "10px",
            borderRadius: '15px'
          }
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default Sidebar;
